// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const START_LOADING_AUTH = 'START_LOADING_AUTH';
export const STOP_LOADING_AUTH = 'STOP_LOADING_AUTH';
export const FORGOT_PASSWORD_USERNAME = 'FORGOT_PASSWORD_USERNAME';
